import type { RouteRecordRaw } from 'vue-router'

const statisticsRoutes: RouteRecordRaw[] = [
  {
    path: '/statistics',
    name: 'statistics',
    component: () => import('@/views/statistics/StatisticsIndex.vue'),
    meta: { titleKey: 'routes.statistics.title', icon: 'DataAnalysis', helpKey: 'statistics' }
  }
]

export default statisticsRoutes
